import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { SurveyListResponse, SurveyDetailResponse, SurveyResponse } from '../model/surveydetailinfo';
import { Subject } from 'rxjs';

@Injectable()
export class SurveyService {
    public surveyList = new Subject();

constructor(public http: HttpClient) {
    }

    // function call to fetch survey list
    public getSurveyList() {
        return this.http.get<SurveyListResponse[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/surveys');
    }
    public getSurveyDetail(id: number, requestId: number) {
        if (requestId) {
            let params = new HttpParams()
                .set('requestId', requestId.toString());
            return this.http.get<SurveyDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
                '/customer/surveys/' + id, { params });
        } else {
            return this.http.get<SurveyDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
                '/customer/surveys/' + id);
        }
    }
    public createSurvey(surveyId: number, surveyResponse: SurveyResponse) {
        return this.http
        .post<SurveyResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
         '/customer/surveys/' + surveyId, surveyResponse);
    }
    public surveyListCount(surveyEmpty: boolean) {
        return this.surveyList.next(surveyEmpty);
    }

}
